<template>
  <ParticleField />
  <main class="app">
    <CalculatorApp />
  </main>
</template>

<script setup>
import './styles/theme.css';
import CalculatorApp from './components/CalculatorApp.vue';
import ParticleField from './components/ParticleField.vue';
</script>

<style>
#app {
  min-height: 100vh;
}

.app {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
